import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

@Component({
  selector: 'lm-application-menu-search-field',
  templateUrl: 'lm-application-menu-search-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
  })
export class LMApplicationMenuSearchFieldComponent implements OnInit, AfterViewInit {
  @Input() testVersion1: boolean;
  @Input() model: any;
  @Input() collapsibleOnMobile: boolean;
  @Input() menuV3 = false;

  @HostBinding('class.has-search-results') @Input() menuSearchMode: boolean;

  @Output() autoSearchMenu: EventEmitter<any> = new EventEmitter<any>();
  @Output() fireMenuSearchEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() fireClearSearchEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() menuSearchCleared: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('searchField') searchField: ViewContainerRef;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {

    /**
     * LMCLIENT-37027
     * Trigger keyup event after DOM is finished loading
     * This will cause the "x" clear button to display in the search input without user interaction
     * The normal functionality for the search control only shows the clear button after a key event
     * Whereas in this use case we need it to show after initial load because the search has been pre-populated
     * And the search button closes the search overlay when clicked.
     */
    this.triggerKeyUpEventOnSearch();
  }

  public onAutoSearchMenu($event: any): void {
    this.autoSearchMenu.emit($event);
  }

  public onFireMenuSearchEvent($event: any): void  {
    this.fireMenuSearchEvent.emit($event);
  }

  public onFireClearSearchEvent($event: any): void  {
    this.fireClearSearchEvent.emit($event);
  }

  private triggerKeyUpEventOnSearch(): void  {
    const event = new KeyboardEvent('keyup', { bubbles:true });
    setTimeout(() => this.searchField.element.nativeElement.dispatchEvent(event));
  }

  public onMenuSearchCleared($event: MouseEvent): void  {
    this.model.searchFieldValue = '';
    this.menuSearchCleared.emit();
  }
}
